import { faSave } from "@fortawesome/free-solid-svg-icons";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useUserInfor } from "../../../../Context/User";
import { ListarAtributosVinculadosPorEtapaTipoCasoRepasseController } from "../../../../Controllers/Geral/AtributosEtapa/AtributosEtapaController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IAtendimentoRepasseCaso } from "../../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";
import UnForm from "../../../Form";
import OrSpinner from "../../../Utils/OrSpinner";
import RepasseDados from "../RepasseDados";
import RepasseFinanceiro from "../RepasseFinanceiro";

interface IRepasseCaso {
    gestaoRepasseDados?: IAtendimentoRepasseCaso | undefined;
    gestaoRepasseDadosLoading?: boolean;
    salvando?: boolean;
    handleRepasseFinanceiro?: any;
}

export default function RepasseCaso(props: IRepasseCaso) {
    const { Atendimento } = useAtendimentoPage();
    const { Config } = useUserInfor();

    const { value: atributosPorEtapa } = useAsyncEffect(
        () =>
            ListarAtributosVinculadosPorEtapaTipoCasoRepasseController(
                Atendimento?.ID_TIPO_CASO ?? 0,
                Atendimento?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO ?? 0
            ),
        [Atendimento?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO]
    );

    return (
        <>
            {
                atributosPorEtapa !== undefined && atributosPorEtapa.length > 0 ? (
                    <div className="d-flex row card card-custom col-12 justify-content-around p-4">
                        <UnForm
                            className="col-12 d-flex justify-content-between aling-item-center row "
                            handleSubmit={props.handleRepasseFinanceiro}
                        >
                            <OrSpinner
                                loading={props.gestaoRepasseDadosLoading ?? false}
                                loadingColor="primary"
                                wrapperLoadingClasses="w-100 d-flex align-items-center justify-content-center"
                            >
                                {props.gestaoRepasseDados ? (
                                    <>
                                        <RepasseDados
                                            gestaoRepasseDados={props.gestaoRepasseDados}
                                            idTipoCaso={Atendimento?.ID_TIPO_CASO}
                                            idEtapaCategoriaAtendimento={
                                                Atendimento?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                            }
                                            atributosPorEtapa={atributosPorEtapa}
                                        />

                                        {(
                                            atributosPorEtapa?.filter(
                                                (atributo) =>
                                                    atributo.DS_ATRIBUTO === "BLOCO_VALORES"
                                            ) || []
                                        ).length > 0 && (
                                                <RepasseFinanceiro
                                                    gestaoRepasseDados={
                                                        props.gestaoRepasseDados
                                                    }
                                                />
                                            )}
                                        {!Config?.ConfigAtendimentoDTO
                                            .FL_AVANCAR_ETAPA_REPASSE && (
                                                <div className="aling-items-center d-flex mt-5 justify-content-end w-100 col-12 p-4">
                                                    <UnForm.SubmitButton
                                                        loading={props.salvando}
                                                        disabled={props.salvando}
                                                        loadingSize={"sm"}
                                                        className="col-12"
                                                        icon={faSave}
                                                        color="primary"
                                                    >
                                                        {" "}
                                                        Salvar
                                                    </UnForm.SubmitButton>
                                                </div>
                                            )}
                                    </>
                                ) : (
                                    <div className="text-center text-muted">
                                        Erro ao carregar
                                    </div>
                                )}
                            </OrSpinner>
                        </UnForm>
                    </div>
                ) : (
                    <div className="text-center text-muted">
                        Não existe nenhum atributo cadastrado para esta etapa
                    </div>
                )
            }
        </>
    );
}
